module.exports = __webpack_public_path__ + "media/images/mypage/mymenu_1-504c6d87843dd9e148b33ceb65dca6ec.gif";